import React, { useState } from 'react';
import RoleBasedHeader from '../../components/ui/RoleBasedHeader';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import Icon from '../../components/AppIcon';
import AvailableQuotaTab from './components/AvailableQuotaTab';
import FactoryDetailsTab from './components/FactoryDetailsTab';
import TransporterNetworkTab from './components/TransporterNetworkTab';
import BuyerManagementTab from './components/BuyerManagementTab';
import PurchaseHubTab from './components/PurchaseHubTab';

const SugarQuota = () => {
  const [activeTab, setActiveTab] = useState('quota');

  const tabs = [
    { id: 'quota', label: 'Available Quota', icon: 'Package' },
    { id: 'factories', label: 'Factory Details', icon: 'Factory' },
    { id: 'transporters', label: 'Transporter Network', icon: 'Truck' },
    { id: 'buyers', label: 'Buyer Management', icon: 'Users' },
    { id: 'purchase', label: 'Purchase Hub', icon: 'ShoppingCart' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'quota':
        return <AvailableQuotaTab />;
      case 'factories':
        return <FactoryDetailsTab />;
      case 'transporters':
        return <TransporterNetworkTab />;
      case 'buyers':
        return <BuyerManagementTab />;
      case 'purchase':
        return <PurchaseHubTab />;
      default:
        return <AvailableQuotaTab />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <RoleBasedHeader />
      <BreadcrumbNavigation />
      <main className="main-content">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="mb-4">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#1e4a72] to-[#ff8c00] flex items-center justify-center">
                <Icon name="Boxes" size={24} color="#FFFFFF" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-foreground">Sugar Quota</h1>
                <p className="text-muted-foreground">Private platform for sugar quota management and distribution</p>
              </div>
            </div>
          </div>

          {/* Desktop Tabs */}
          <div className="hidden md:block bg-card rounded-lg border border-border mb-6">
            <div className="flex items-center gap-2 p-2 overflow-x-auto">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 px-4 py-3 rounded-md text-sm font-medium transition-all whitespace-nowrap ${
                    activeTab === tab?.id
                      ? 'bg-gradient-to-r from-[#1e4a72] to-[#ff8c00] text-white shadow-lg'
                      : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                  }`}
                >
                  <Icon name={tab?.icon} size={18} />
                  <span>{tab?.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Mobile Tabs - Dropdown Style */}
          <div className="md:hidden mb-6">
            <div className="relative">
              <select
                value={activeTab}
                onChange={(e) => setActiveTab(e?.target?.value)}
                className="w-full px-4 py-3 bg-card border-2 border-[#ff8c00]/30 rounded-lg text-foreground font-medium appearance-none cursor-pointer focus:ring-2 focus:ring-[#ff8c00] focus:border-[#ff8c00] shadow-sm"
                style={{
                  backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%23ff8c00' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
                  backgroundPosition: 'right 0.75rem center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '1.5em 1.5em',
                  paddingRight: '3rem'
                }}
              >
                {tabs?.map((tab) => (
                  <option key={tab?.id} value={tab?.id}>
                    {tab?.label}
                  </option>
                ))}
              </select>
              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                <Icon 
                  name={tabs?.find(t => t?.id === activeTab)?.icon || 'Boxes'} 
                  size={20} 
                  className="text-[#ff8c00]"
                />
              </div>
            </div>
          </div>

          <div className="transition-all duration-300">
            {renderTabContent()}
          </div>
        </div>
      </main>
    </div>
  );
};

export default SugarQuota;